import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-medium text-gray-600" }
const _hoisted_2 = { class: "sm:col-span-12" }
const _hoisted_3 = { class: "mb-2 block text-sm font-medium text-gray-800" }
const _hoisted_4 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4 text-center" }

import { computed, onMounted, PropType, Ref, ref, WritableComputedRef } from 'vue';
import {
    ConnectFlowModelingActions,
    ConnectFlowModelingGetters,
    ConnectFlowModelingMutations,
    VueFlowNodeModel,
    SelectOptionsServiceGetConnectFlowsResult,
} from '@/types';
import store from '@/store';
import { ExternalLinkIcon } from '@heroicons/vue/outline';

import { useVuelidate, Validation, ValidationArgs } from '@vuelidate/core';
import { required } from '@/utils/validators';
import { useI18n } from 'vue-i18n';
import { SelectOptionsService } from '@/services';

interface GoToFormState {
    connectFlow: number | null;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GoToConnectFlow',
  props: {
    node: {
        type: Object as PropType<VueFlowNodeModel>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const showForm = ref(false);

const nodeWritable: WritableComputedRef<VueFlowNodeModel> = computed({
    get: () => store.getters['flow/' + ConnectFlowModelingGetters.ELEMENT_BY_ID](props.node.id),
    set: (value: VueFlowNodeModel) => {
        store.commit('flow/' + ConnectFlowModelingMutations.UPDATE_ELEMENT, {
            idx: null,
            value,
        });
    },
});

const { t } = useI18n();

const formState: Ref<GoToFormState> = ref({
    connectFlow: null,
});
const rules = computed<ValidationArgs<GoToFormState>>(() => {
    const r: ValidationArgs<GoToFormState> = {
        connectFlow: {
            required,
        },
    };
    return r;
});
const v$: Ref<Validation<ValidationArgs<GoToFormState>>> = useVuelidate(rules, formState);

const isFormCorrect = ref(true);

function removeNode() {
    store.dispatch('flow/' + ConnectFlowModelingActions.DELETE_NODE, {
        nodeId: nodeWritable.value.id,
        parentId: nodeWritable.value.parentId,
    });
}

async function onSubmit() {
    isFormCorrect.value = await v$.value.$validate();
    if (isFormCorrect.value) {
        nodeWritable.value.data.goToConnectFlow = formState.value.connectFlow || undefined;
        showForm.value = false;
    }
    nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    v$.value.$reset();
}

const connectFlowOptions: Ref<SelectOptionsServiceGetConnectFlowsResult[]> = ref([]);

const nodeText = computed(() => {
    let text = t('connectFlow.node.goToConnectFlow.description');
    if (nodeWritable.value.data.goToConnectFlow) {
        const connectFlow = connectFlowOptions.value.find(
            (e) => e.id == nodeWritable.value.data.goToConnectFlow,
        );
        text = connectFlow?.name ?? '';
    }
    return text;
});

onMounted(async () => {
    if (nodeWritable.value.data.goToConnectFlow !== undefined) {
        formState.value.connectFlow = nodeWritable.value.data.goToConnectFlow;
    }

    const { data } = await SelectOptionsService.getConnectFlows();
    connectFlowOptions.value = data;

    v$.value.$validate().then((result) => {
        isFormCorrect.value = result;
        nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    });
});

return (_ctx: any,_cache: any) => {
  const _component_UiNode = _resolveComponent("UiNode")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiNode, {
      nodeId: __props.node.id,
      title: _ctx.$t('connectFlow.node.goToConnectFlow.title'),
      icon: _unref(ExternalLinkIcon),
      showActions: "",
      onEditNode: _cache[0] || (_cache[0] = ($event: any) => (showForm.value = true)),
      onRemoveNode: removeNode,
      class: _normalizeClass(isFormCorrect.value ? '' : 'border-red-300 shadow-red-300')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(nodeText.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["nodeId", "title", "icon", "class"]),
    _createVNode(_component_UiRightPanel, {
      modelValue: showForm.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showForm).value = $event)),
      title: _ctx.$t('connectFlow.node.goToConnectFlow.title'),
      icon: _unref(ExternalLinkIcon)
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          autocomplete: "off",
          class: "flex flex-col gap-3",
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('connectFlow.node.goToConnectFlow.helpText')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "schedule",
              modelValue: _unref(v$).connectFlow.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).connectFlow.$model) = $event)),
              options: connectFlowOptions.value,
              errors: _unref(v$).connectFlow.$errors,
              label: "name",
              "value-prop": "id",
              primitive: "",
              required: ""
            }, null, 8, ["modelValue", "options", "errors"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_UiButton, {
              variant: "white",
              textVariant: "gray-700",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showForm.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_UiButton, {
              type: "submit",
              variant: "primary",
              textVariant: "white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["modelValue", "title", "icon"])
  ], 64))
}
}

})